import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  list: [],
  isFetching: false,
  isSaving: false,
};

const creditRiskClasses = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_RISK_CLASS_LIST:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_CREDIT_RISK_CLASS_LIST:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditRiskClasses;
